'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('./button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var CloseFancyBoxButton = _react2['default'].createClass({
    displayName: 'CloseFancyBoxButton',

    render: function render() {
        var closeFancyBox = function closeFancyBox() {
            parent.$.fancybox.close();
        };
        return _react2['default'].createElement(_button2['default'], _extends({}, this.props, { onClick: closeFancyBox }));
    }
});

module.exports = CloseFancyBoxButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/close-fancy-box-button.jsx
 ** module id = 629
 ** module chunks = 0
 **/